import React from 'react';
export function FitFilterSection() {
  return <section id="fit" className="py-24 md:py-32 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-70">
      <div className="mb-20" data-id="element-71">
        <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-72">
          Fit Filter
        </h2>
        <h3 className="text-3xl md:text-4xl font-light text-black" data-id="element-73">
          Who this is (and isn't) for
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24" data-id="element-74">
        <div data-id="element-75">
          <h4 className="text-xl font-medium text-black mb-8 pb-2 border-b border-gray-200 inline-block" data-id="element-76">
            This fits if:
          </h4>
          <ul className="space-y-6" data-id="element-77">
            <li className="flex items-start" data-id="element-78">
              <span className="mr-4 text-black font-medium" data-id="element-79">—</span>
              <span className="text-lg text-gray-600" data-id="element-80">
                You're pre-PMF or at a moment where the next milestone carries
                outsized consequences
              </span>
            </li>
            <li className="flex items-start" data-id="element-81">
              <span className="mr-4 text-black font-medium" data-id="element-82">—</span>
              <span className="text-lg text-gray-600" data-id="element-83">
                Runway feels tight and expectations are rising
              </span>
            </li>
            <li className="flex items-start" data-id="element-84">
              <span className="mr-4 text-black font-medium" data-id="element-85">—</span>
              <span className="text-lg text-gray-600" data-id="element-86">
                Time feels like the scarcest resource right now
              </span>
            </li>
            <li className="flex items-start" data-id="element-87">
              <span className="mr-4 text-black font-medium" data-id="element-88">—</span>
              <span className="text-lg text-gray-600" data-id="element-89">
                You've raised ahead of your operating maturity
              </span>
            </li>
            <li className="flex items-start" data-id="element-90">
              <span className="mr-4 text-black font-medium" data-id="element-91">—</span>
              <span className="text-lg text-gray-600" data-id="element-92">
                You need momentum without taking on a long-term hire
              </span>
            </li>
          </ul>
        </div>

        <div data-id="element-93">
          <h4 className="text-xl font-medium text-black mb-8 pb-2 border-b border-gray-200 inline-block" data-id="element-94">
            This won't fit if:
          </h4>
          <ul className="space-y-6" data-id="element-95">
            <li className="flex items-start" data-id="element-96">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-97">—</span>
              <span className="text-lg text-gray-400" data-id="element-98">
                You're looking for junior help or simple task delegation
              </span>
            </li>
            <li className="flex items-start" data-id="element-99">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-100">—</span>
              <span className="text-lg text-gray-400" data-id="element-101">
                You want validation more than forward progress
              </span>
            </li>
            <li className="flex items-start" data-id="element-102">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-103">—</span>
              <span className="text-lg text-gray-400" data-id="element-104">
                You're optimizing for scale rather than near-term execution
              </span>
            </li>
            <li className="flex items-start" data-id="element-105">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-106">—</span>
              <span className="text-lg text-gray-400" data-id="element-107">
                You're not open to focused, time-bound changes
              </span>
            </li>
            <li className="flex items-start" data-id="element-108">
              <span className="mr-4 text-gray-300 font-medium" data-id="element-109">—</span>
              <span className="text-lg text-gray-400" data-id="element-110">
                You want someone to avoid hard conversations
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}